"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isSchemaVersion: () => isSchemaVersion,
  isSurvey: () => isSurvey,
  isSurveyF: () => isSurveyF,
  isSurveyMetadata: () => isSurveyMetadata,
  isSurveyModuleSummary: () => isSurveyModuleSummary,
  isSurveyNames: () => isSurveyNames,
  isSurveyStatus: () => isSurveyStatus,
  isSurveySummary: () => isSurveySummary
});
module.exports = __toCommonJS(types_generated_exports);
var import_geometry = require("@cartographerio/geometry");
var import_types_generated = require("../core/types.generated.js");
var import_types_generated2 = require("../user/types.generated.js");
var import_util = require("@cartographerio/util");
const isSurveyNames = (v) => {
  return typeof v === "object" && v != null && "shortName" in v && typeof v.shortName === "string" && "longName" in v && typeof v.longName === "string";
};
const isSchemaVersion = (v) => {
  return (0, import_util.bridgesIsTaggedNumberHack)((a0) => a0 === "SchemaVersion")(v);
};
const isSurveyModuleSummary = (v) => {
  return typeof v === "object" && v != null && "moduleId" in v && (0, import_types_generated.isSurveyModuleId)(v.moduleId) && "names" in v && isSurveyNames(v.names);
};
const isSurveyStatus = (v) => {
  return v === "draft" || v === "complete" || v === "approved" || v === "review" || v === "rejected";
};
const isSurveyF = (isA) => (v) => {
  return typeof v === "object" && v != null && "id" in v && (0, import_types_generated.isSurveyId)(v.id) && "moduleId" in v && (0, import_types_generated.isSurveyModuleId)(v.moduleId) && "projectId" in v && (0, import_types_generated.isProjectId)(v.projectId) && (!("teamId" in v) || (0, import_types_generated.isTeamId)(v.teamId) || v.teamId === null) && "created" in v && (0, import_types_generated.isTimestamp)(v.created) && "updated" in v && (0, import_types_generated.isTimestamp)(v.updated) && "surveyor" in v && (0, import_types_generated2.isUserRef)(v.surveyor) && "status" in v && isSurveyStatus(v.status) && "schemaVersion" in v && isSchemaVersion(v.schemaVersion) && "data" in v && isA(v.data);
};
const isSurveyMetadata = (v) => {
  return typeof v === "object" && v != null && (!("geometry" in v) || (0, import_geometry.isGeometry)(v.geometry) || v.geometry === null) && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null) && "workspaceName" in v && typeof v.workspaceName === "string" && "projectName" in v && typeof v.projectName === "string" && (!("teamName" in v) || typeof v.teamName === "string" || v.teamName === null) && (!("description" in v) || typeof v.description === "string" || v.description === null);
};
const isSurvey = (v) => {
  return isSurveyF((a0) => true)(v);
};
const isSurveySummary = (v) => {
  return isSurveyF((a0) => isSurveyMetadata(a0))(v);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isSchemaVersion,
  isSurvey,
  isSurveyF,
  isSurveyMetadata,
  isSurveyModuleSummary,
  isSurveyNames,
  isSurveyStatus,
  isSurveySummary
});
//# sourceMappingURL=types.generated.js.map
